// Copyright (c) 2016 Deere & Company

import {
    applySearchFilters,
    resetProductSearchFacets,
    selectAllDealersOnInitialLoad,
    updateProductSearchDealerFacetInput,
    updateProductSearchDealerFacetItem,
    updateProductSearchDealerFacetItems,
    updateProductSearchStatusFacetItem,
    updateProductSearchStatusFacetItems,
    updateRegisteredDateRangeFacet
} from './facets';
import {
    getClaimTypeList,
    onCreateClaim,
    toggleCreateClaimModal
} from './create-claim-modal';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {getProductSearchStatus} from './get-product-status';
import {goToStatusChangeRequestView} from '../../shared/action-creators/status-change-request-view';
import {highRentalDaysExportToExcel} from '../../shared/action-creators/high-rental-days-export-to-excel.js';
import sharedActionCreators from '../../shared/action-creators';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateProduct} from './product';
import {updateRegistrationResults} from '../../registration-review/action-creators/registration';
import {updateSearchResults} from './search';
import {updateStatusChangeModalVisibility} from './status-change-modal-visibility';

export default {
    ...exportToExcelActions,
    ...sharedActionCreators,
    applySearchFilters,
    getClaimTypeList,
    getProductSearchStatus,
    goToStatusChangeRequestView,
    highRentalDaysExportToExcel,
    onCreateClaim,
    resetProductSearchFacets,
    selectAllDealersOnInitialLoad,
    toggleCreateClaimModal,
    toggleReportsAccordion,
    updateProduct,
    updateProductSearchDealerFacetInput,
    updateProductSearchDealerFacetItem,
    updateProductSearchDealerFacetItems,
    updateProductSearchStatusFacetItem,
    updateProductSearchStatusFacetItems,
    updateRegisteredDateRangeFacet,
    updateRegistrationResults,
    updateSearchResults,
    updateStatusChangeModalVisibility
};



// WEBPACK FOOTER //
// ./src/product/search/action-creators/index.js